import React from 'react'
import { useState } from 'react';
import { FaEdit, FaPlus, FaTimes, FaTrash } from 'react-icons/fa';
import MyButton from '../../UI/button/MyButton';
import Card from '../../UI/Card/Card'
import MyInput from '../../UI/input/MyInput';
import MySelect from '../../UI/select/MySelect';
import GenericTable from '../../UI/table/GenericTable';
import CustomDatePicker from '../CustomDatePicker';
import InputWrapper from '../InputWrapper';
import Overlay from '../Overlay';
import { useDMSContext } from '../../context/DMSContext';
import contractService from '../../services/ContractService';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import { contractStatuses, currencies, paysFrequency } from '../../assets/data/option';
import { format } from 'date-fns';

export default function ContractsSection() {
  const { contracts, debtors, refetchContracts, refetchDebtors } = useDMSContext();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatus, setSelectedStatus] = useState(contractStatuses[0]);
  const [overlay, setOverlay] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingContractId, setEditingContractId] = useState(null);
  const navigate = useNavigate();
  const [contract, setContract] = useState({
    name: "",
    value: "",
    initialDue: "",
    status: "ACTIVE",            
    currency: 1,          
    penaltyPercentPerDay: "",
    payFrequency: "MONTHLY",     
    startDate: null,
    endDate: null,
    obligationDate: null,
    debtorId: 0           
  });

  const handleOverlay = () => {
      setOverlay(!overlay);
  }

  const handleEditContract = (contractData) => {
      setContract(contractData);
      setIsEditing(true);
      setOverlay(true);
  };

  const deleteContract = async (contractId) => {
    try {
      const response = await contractService.deleteContract(contractId);
      refetchContracts();
      toast.success('Contractul a fost șters cu succes');
    } catch (error) {
      toast.error('Eroare la ștergerea contractului');
    }
  };
  

  const filteredContracts = contracts.filter(c =>
    (selectedStatus.value === 'Toate Statusurile' || c.status === selectedStatus.value) &&
    (c.debtorName?.toLowerCase().includes(searchTerm.toLowerCase()) || c.name.includes(searchTerm))
  );

  const validate = () => {
    if (contract.debtorId == 0 || contract.debtorId == null){
      toast.error('Selectați un debitor');
      return false;
    }
  
    if (contract.name == '' || contract.name == null){
      toast.error('Introduceți denumirea contractului');
      return false;
    }
  
    if (contract.startDate == null){
      toast.error('Selectați data de început');
      return false;
    }
  
    if (contract.endDate == null){
      toast.error('Selectați data de sfârșit');
      return false;
    }
  
    if (contract.obligationDate == null){
      toast.error('Selectați data obligației');
      return false;
    }
  
    if (contract.value == null || contract.value == ""){
      toast.error('Introduceți valoarea contractului');
      return false;
    }
  
    if (contract.initialDue == null || contract.initialDue == ""){
      toast.error('Introduceți suma scadentă inițială');
      return false;
    }
  
    return true;
  };
  

  const submitContract = async (e) => {
    e.preventDefault();
  
    if (!validate()) {
      return;
    }
  
    if (isEditing) {
      try {
        const response = await contractService.updateContract(contract.id, contract);
        refetchContracts();
        refetchDebtors();
        toast.success('Contractul a fost actualizat cu succes');
      } catch (error) {
        toast.error('Eroare la actualizarea contractului');
      }
    } else {
      try {
        const response = await contractService.addContract(contract);
        refetchContracts();
        refetchDebtors();
        toast.success('Contractul a fost adăugat cu succes');
      } catch (error) {
        toast.error('Eroare la adăugarea contractului');
      }
    }
  
    setContract({
      name: "",
      value: "",
      initialDue: "",
      status: "ACTIVE",
      currency: 1,
      penaltyPercentPerDay: "",
      payFrequency: "MONTHLY",
      startDate: null,
      endDate: null,
      obligationDate: null,
      debtorId: 0
    });
    setIsEditing(false);
    setOverlay(false);
  };
  
    
  const contractColumns = [
      { Header: 'NUMĂR CONTRACT', accessor: 'name' },
      { Header: 'DEBITOR', accessor: 'debtorName',
        enableCellClick: false,
        Cell: ({ row }) => {
          return <Link to={`/dms/debtors/${row.original.debtorId}`}  onClick={(e) => {e.stopPropagation()}}>{row.original.debtorName}</Link>
        }
      },
      { Header: 'DATA ÎNCHEIERII', accessor: 'startDate',
      Cell: ({ value }) => {
        try {
          const date = new Date(value);
          return isNaN(date) ? '' : format(date, 'dd.MM.yyyy');
        } catch {
          return '';
        }
      } },
      { Header: 'DATA FINALIZĂRII', accessor: 'endDate',
      Cell: ({ value }) => {
        try {
          const date = new Date(value);
          return isNaN(date) ? '' : format(date, 'dd.MM.yyyy');
        } catch {
          return '';
        }
      } },
      {
        Header: 'VALOARE CONTRACT',
        accessor: 'value',
        Cell: ({ row }) => {
          const { value, currency } = row.original;
          return <span>{parseFloat(value).toFixed(2)} {currency}</span>;
        }
      },
      {
        Header: 'RESTANȚĂ CURENTĂ',
        accessor: 'debt',
        Cell: ({ row }) => {
          const { debt, currency } = row.original;
          return <span className={debt > 0 ? 'text-danger' : ''}>
            {parseFloat(debt).toFixed(2)} {currency}
          </span>
        }
      },
      {
        Header: 'PENALITĂȚI',
        accessor: 'penalty',
        Cell: ({ row }) => {
          const { penalty, currency } = row.original;
          return <span className={penalty > 0 ? 'text-warning' : ''}>
            {parseFloat(penalty).toFixed(2)} {currency}
          </span>
        }
      },
      {
        Header: 'STATUS',
        accessor: 'status',
        Cell: ({ value }) => {
          const statusObj = contractStatuses.find(s => s.value == value);
          const label = statusObj ? statusObj.label : value;
          return (<span className={value === 'ACTIVE' ? 'badge-active' : 'badge-inactive'}>
            {label}
          </span>);
        }
      },
      {
          Header: 'ACȚIUNI',
          enableCellClick: false,
          Cell: ({ row }) => (
            <div className="actions">
              <button className="edit" onClick={(e) => {e.stopPropagation();handleEditContract(row.original)}}>
                <FaEdit />
              </button>
              <button className="delete" onClick={(e) => {e.stopPropagation();deleteContract(row.original.id)}}>
                <FaTrash />
              </button>
            </div>
          )
        }      
  ];
  return (
    <div className='dms-content'>
      <div className='section-header'><h2>Lista Contractelor</h2>
      <MyButton
      style={{maxWidth:"245px",color:"var(--prolex-blue)",borderColor:"var(--prolex-blue)"}}
      id="addSettlementBtn"
      body={<span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}><FaPlus/>Adaugă Contract Nou</span>}
      type="button"
      onClick={handleOverlay}
      />
      </div>
      <div className='flex-row'>
          <Card style={{padding:"1rem"}}>
              <div className='flex-row' style={{width:"100%"}}>
                  <div className="calc-search" style={{width:"50%"}}>
                  <MyInput
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  type="text"
                  placeholder="Caută după număr, debitor..."
                  />
              {searchTerm && (
                  <button type="button" className="clear-search-icon" onClick={null}>
                      <FaTimes />
                  </button>
                  )}
                  </div>
                  <div style={{width:"50%"}}>
                      <MySelect 
                          options={contractStatuses} 
                          name="contractStatuses"
                          value={selectedStatus}
                          customOnChange={(selectedOption) => setSelectedStatus(selectedOption)}
                          style
                      />
                  </div>
              </div>
          </Card>
      </div>
          <Card style={{padding:"1rem"}}>

              <GenericTable data={filteredContracts} columns={contractColumns} onRowClick={(row) => navigate(`/dms/contracts/${row.original.id}`)}/>
          </Card>
          <Overlay
            handleOverlay={handleOverlay}
            isOpen={overlay}
            maxWidth="55vw"
          >
            <h2 style={{marginBottom:"2rem"}}>Adaugă Contract Nou</h2>
            <form onSubmit={submitContract} className='form-container'>

            <div className='myInpWrapper'>
              <label htmlFor={"debtors"} className={'myInpLabel'}>Debitor <span style={{color:"red"}}>*</span></label>
                <MySelect 
                  options={[{ value: 0, label: " --Selectează debitorul-- " }, ...debtors.map(d => ({ value: d.id, label: d.name }))]}
                  name="debtors"
                  value={[{ value: 0, label: " --Selectează debitorul-- " }, ...debtors.map(d => ({ value: d.id, label: d.name }))].find(
                    option => option.value === contract.debtorId
                  )}
                  onChange={(selectedOption) => setContract(prev => ({ ...prev, debtorId: selectedOption || '' }))}
                />
              </div>
        
            <InputWrapper
              isRequired={true}
              value={contract.name}
              onChange={(e) => setContract(prev => ({...prev, name:e.target.value}))}
              type="text"
              name='contractName'
              body={<>Număr/Denumire Contract <span style={{color:"red"}}>*</span></>}
            />

            <div className='myInpWrapper'>
              <label htmlFor="datepicker2" className='myInpLabel'>Data Încheierii<span style={{color:"red"}}>*</span></label>
                <CustomDatePicker 
                  value={contract.startDate} 
                  onChange={(date) => {setContract(prev => ({ ...prev, startDate: date }));}} 
                  name="datepicker2"
                  isRequired={true}
                />
            </div>
            <div className='myInpWrapper'>
              <label htmlFor="datepicker2" className='myInpLabel'>Data Obligațiunii<span style={{color:"red"}}>*</span></label>
                <CustomDatePicker 
                  value={contract.obligationDate} 
                  onChange={(date) => {setContract(prev => ({ ...prev, obligationDate: date }));}} 
                  name="datepicker2"
                  isRequired={true}
                />
            </div>
            <div className='myInpWrapper'>
            <label htmlFor="datepicker2" className='myInpLabel'>Finalizarea Contractului<span style={{color:"red"}}>*</span></label>
                <CustomDatePicker 
                  value={contract.endDate} 
                  onChange={(date) => {setContract(prev => ({ ...prev, endDate: date }));}} 
                  name="datepicker2"
                  isRequired={true}
                />
            </div>
            <InputWrapper
              value={contract.value}
              onChange={(e) => setContract(prev => ({...prev, value:e.target.value}))}
              type="text"
              name='contractValue'
              body={<>Valoarea Totală a Contractului <span style={{color:"red"}}>*</span></>}
              isNumeric={true}
              isRequired={true}
            />
            <div className='myInpWrapper'>
              <label htmlFor={"debtors"} className={'myInpLabel'}>Valuta</label>
                <MySelect 
                  options={currencies}
                  name="currencies"
                  value={currencies.find(option => option.value === contract.currency)}
                  onChange={(selectedOption) => {setContract(prev => ({ ...prev, currency: selectedOption || '' }))}}
                />
            </div>
            <InputWrapper
              value={contract.penaltyPercentPerDay}
              onChange={(e) => setContract(prev => ({...prev, penaltyPercentPerDay:e.target.value}))}
              type="text"
              name='contractValue'
              body="Procent Penalitate Zilnică (%)"
              isNumeric={true}
            />
            <div className='myInpWrapper'>
              <label htmlFor={"debtors"} className={'myInpLabel'}>Frecvența Plăților</label>
                <MySelect 
                  options={paysFrequency}
                  name="paysFrequency"
                  value={paysFrequency.find(option => option.value === contract.payFrequency)}
                  onChange={(selectedOption) => setContract(prev => ({ ...prev, payFrequency: selectedOption || '' }))}
                />
            </div>
            <InputWrapper
              value={contract.initialDue}
              onChange={(e) => setContract(prev => ({...prev, initialDue:e.target.value}))}
              type="text"
              name='contractInitialDue'
              body={<>Suma Inițială Datorată <span style={{color:"red"}}>*</span></>}
              isNumeric={true}
              isRequired={true}
            />
            <div className='myInpWrapper'>
              <label htmlFor={"debtors"} className={'myInpLabel'}>Status Contract</label>
                <MySelect 
                  options={contractStatuses.filter(option => option.value !== 'Toți')}
                  name="contractStatuses"
                  value={contractStatuses.find(option => option.value === contract.status)}
                  onChange={(selectedOption) => setContract(prev => ({ ...prev, status: selectedOption || '' }))}
                />
            </div>
            <div className='flex-row' style={{justifyContent:"flex-end"}}>
            <MyButton
              style={{maxWidth:"175px",color:"var(--prolex-red)",borderColor:"var(--prolex-red)"}}
              id="cancelBtn"
              body="Anulează"
              onClick={handleOverlay}
            />
            <MyButton
              style={{maxWidth:"245px",color:"var(--prolex-blue)",borderColor:"var(--prolex-blue)"}}
              id="addContractBtn"
              body={<>Salvează Contract</>}
              type='submit'
            />
        </div>
      </form>
    </Overlay>

    </div>   
  )
}
